import { Component } from '@angular/core';
import { CouponFormComponentDef } from '@df/basket/coupon-form.component.def';

export interface ICouponFormData {
    coupon: string | string[];
    checkout?: boolean;
}

@Component({
    selector: 'basket-view-coupon-form',
    templateUrl: 'basket-view-coupon-form.html',
    styles: [
        `
            :host {
                border-radius: 4px;
            }
        `
    ]
})
export class BasketViewCouponFormComponent extends CouponFormComponentDef {}
